import React from 'react';
import { ArrowRight, MapPin, Clock, Shield, UserCheck } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[92vh] flex items-center pt-20 pb-4 lg:pb-0 bg-black lg:bg-[#0a0a0a]">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 hidden lg:block">
        <img
          src="https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/zbsvd73x_ChatGPT%20Image%20Mar%201%2C%202026%2C%2010_23_19%20PM.png"
          alt="SG Cabs - Your Trusted Ride"
          data-testid="hero-car-image"
          className="w-full h-full object-contain object-right-bottom opacity-70 pb-12 pr-8"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-black/20"></div>
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#0a0a0a] to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
        <div className="max-w-3xl">
          <p className="lux-overline mb-5" data-testid="hero-overline">Your Journey, Our Priority · The Gold Standard of Rides</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white mb-6 leading-[1.1] tracking-tight">
            Premium Taxi Service in Bangalore
            <span className="block text-[#d4af37]">Airport Taxi &amp; Outstation Cabs</span>
          </h1>

          <p className="text-lg text-gray-300 mb-10 leading-relaxed max-w-xl">
            24/7 Bangalore airport transfers from ₹1350, outstation cabs at ₹14/km, fixed one way
            drops to Hyderabad, Chennai, Mysuru &amp; Goa, and hourly rentals — professional
            chauffeurs, transparent fares, always on time.
          </p>

          {/* Feature Chips */}
          <div className="flex flex-wrap gap-3 mb-12">
            <div className="flex items-center gap-2 rounded-full bg-[#1a1a1a]/80 backdrop-blur-md px-5 py-2.5 border border-white/10">
              <Clock className="w-4 h-4 text-[#d4af37]" aria-hidden="true" />
              <span className="text-gray-200 text-sm font-medium">24/7 Available</span>
            </div>
            <div className="flex items-center gap-2 rounded-full bg-[#1a1a1a]/80 backdrop-blur-md px-5 py-2.5 border border-white/10">
              <MapPin className="w-4 h-4 text-[#d4af37]" aria-hidden="true" />
              <span className="text-gray-200 text-sm font-medium">All Over India</span>
            </div>
            <div className="flex items-center gap-2 rounded-full bg-[#1a1a1a]/80 backdrop-blur-md px-5 py-2.5 border border-white/10">
              <Shield className="w-4 h-4 text-[#d4af37]" aria-hidden="true" />
              <span className="text-gray-200 text-sm font-medium">Safe & Reliable</span>
            </div>
            <div className="flex items-center gap-2 rounded-full bg-[#1a1a1a]/80 backdrop-blur-md px-5 py-2.5 border border-white/10">
              <UserCheck className="w-4 h-4 text-[#d4af37]" aria-hidden="true" />
              <span className="text-gray-200 text-sm font-medium">Professional Drivers</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              onClick={scrollToBooking}
              size="lg"
              data-testid="hero-book-now-btn"
              className="rounded-full bg-[#d4af37] hover:bg-[#c9a35c] text-black font-semibold text-base px-10 py-6 shadow-[0_0_40px_rgba(212,175,55,0.25)] transition-colors"
            >
              Book Your Ride Now
              <ArrowRight className="ml-2 w-5 h-5" aria-hidden="true" />
            </Button>
            <a href="tel:+917507867648">
              <Button
                size="lg"
                variant="outline"
                data-testid="hero-call-btn"
                className="rounded-full bg-transparent hover:bg-[#d4af37]/10 text-[#d4af37] hover:text-[#d4af37] border border-[#d4af37]/50 text-base px-10 py-6 transition-colors w-full sm:w-auto"
              >
                Call +91 75078 67648
              </Button>
            </a>
          </div>

          {/* Mobile car image - full view below CTAs */}
          <img
            src="https://customer-assets.emergentagent.com/job_cab-service-preview/artifacts/zbsvd73x_ChatGPT%20Image%20Mar%201%2C%202026%2C%2010_23_19%20PM.png"
            alt="SG Cabs taxi"
            data-testid="hero-car-image-mobile"
            className="lg:hidden w-full max-w-md mx-auto mt-8 object-contain"
          />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden lg:block">
        <div className="w-6 h-10 rounded-full border border-[#d4af37]/40 flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-[#d4af37]/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};
